module.exports = __webpack_public_path__ + "img/apple-music.2619b79.svg";